<template>
  <div>
    <h3 class="mb-5">Content</h3>
    <div class="h4 mb-5">
      至少需填寫一組 <br />
      於前台左圖右字、右圖左字交錯排版
    </div>
    <div class="d-flex">
      <div class="flex-grow-1">
        <PageCollapse
          v-for="(item, i) in quiktip.content"
          :key="i"
          :draggable="true"
          @dragstart="dragStart(i)"
          @dragover.prevent="dragOver"
          @drop="drop(i)"
          @dragenter.prevent
        >
          <template v-slot:head>
            <h3 class="mr-auto">Description {{ i + 1 }}</h3>
          </template>
          <template v-slot:actions>
            <div class="ml-auto">
              <button class="btn square mr-10px" @click="deleteItem(i)">
                <v-icon class="ink-02-medium--text">delete</v-icon>
              </button>
            </div>
          </template>
          <template v-slot:body>
            <!-- Title -->
            <label class="form-item d-flex pt-5">
              <h4 class="w-160px mr-5">Title</h4>
              <div class="my-n2 flex-grow-1">
                <v-text-field
                v-model="item.title"
                :id="'sloganInput_' + i"
                outlined dense></v-text-field>
              </div>
            </label>
            <!-- Description -->
            <label class="form-item d-flex pt-5">
              <h4 class="w-160px mr-5">Description</h4>
              <div class="my-n2 flex-grow-1">
                <editor
                  v-model="item.description"
                  :plugins="'link image lists code'"
                  :toolbar="'bold italic | link image | bullist numlist | code'"
                />
              </div>
            </label>
            <!-- img uploader -->
            <div class="form-item d-flex px-5 py-5">
              <div class="w-180px">
                <h4 class="mb-10px">Visual</h4>
                <div class="h5 ink-02-medium--text">
                  建議尺寸：999px * 999px <br />
                  檔案大小限制：&lt; 1 MB
                </div>
              </div>
              <div class="d-flex justify-end flex-grow-1">
                <ImgUploader
                  :imageUrl.sync="item.visual"
                  dir="quiktips"></ImgUploader>
              </div>
            </div>
          </template>
        </PageCollapse>
        <!-- add Content Section -->
        <div class="mt-5 mb-9">
          <button class="btn btn-outlined w-100 justify-start" @click="addItem">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>添加Content Section</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import PageCollapse from '@/components/PageCollapse.vue';
import Editor from '@/components/TinymceEditor.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    quiktip: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PageCollapse,
    Editor,
    ImgUploader,
  },
  data: () => ({
    dir: 'quiktips',
    templateName: 'QuiktipDescription',
  }),
  methods: {
    ...mapActions({
      upload: 'upload',
    }),
    addItem() {
      if (!this.quiktip.content) {
        this.quiktip.content = [];
      }
      const template = {
        id: null,
        title: '',
        description: '',
      };
      this.quiktip.content.push(template);
      this.$forceUpdate();// 強制更新組件
    },
    deleteItem(index) {
      this.quiktip.content.splice(index, 1);
    },
  },
};
</script>

<style></style>
